var map = {
	"./014-wales.svg": 6330,
	"./019-ceuta.svg": 6331,
	"./023-cocos-island.svg": 6332,
	"./031-corsica.svg": 6333,
	"./046-micronesia.svg": 6334,
	"./048-abkhazia.svg": 6335,
	"./052-kosovo.svg": 6336,
	"./054-canary-islands.svg": 6337,
	"./055-scotland.svg": 6338,
	"./061-saba-island.svg": 6339,
	"./070-tuvalu-1.svg": 6340,
	"./072-bonaire.svg": 6341,
	"./079-st-barts.svg": 6342,
	"./082-united-nations.svg": 6343,
	"./087-aland-islands.svg": 6344,
	"./089-sint-maarten.svg": 6345,
	"./093-basque-country.svg": 6346,
	"./095-pitcairn-islands.svg": 6347,
	"./101-northern-cyprus.svg": 6348,
	"./102-balearic-islands.svg": 6349,
	"./103-marshall-island.svg": 6350,
	"./112-laos.svg": 6351,
	"./114-british-virgin-islands.svg": 6352,
	"./116-curacao.svg": 6353,
	"./118-malasya.svg": 6354,
	"./119-brunei.svg": 6355,
	"./123-british-columbia.svg": 6356,
	"./124-vatican-city.svg": 6357,
	"./129-ossetia.svg": 6358,
	"./130-sicily.svg": 6359,
	"./139-venezuela.svg": 6360,
	"./140-east-timor.svg": 6361,
	"./142-tibet.svg": 6362,
	"./148-madeira.svg": 6363,
	"./157-republic-of-the-congo.svg": 6364,
	"./160-northern-marianas-islands.svg": 6365,
	"./161-ivory-coast.svg": 6366,
	"./171-galapagos-islands.svg": 6367,
	"./172-st-lucia.svg": 6368,
	"./175-rapa-nui.svg": 6369,
	"./190-uzbekistn.svg": 6370,
	"./197-melilla.svg": 6371,
	"./202-taiwan.svg": 6372,
	"./203-sahrawi-arab-democratic-republic.svg": 6373,
	"./208-palestine.svg": 6374,
	"./215-falkland-islands.svg": 6375,
	"./216-england.svg": 6376,
	"./223-turks-and-caicos.svg": 6377,
	"./231-libya.svg": 6378,
	"./233-transnistria.svg": 6379,
	"./236-republic-of-macedonia.svg": 6380,
	"./240-azores-islands.svg": 6381,
	"./241-st-vincent-and-the-grenadines.svg": 6382,
	"./244-south-sudan.svg": 6383,
	"./247-somaliland.svg": 6384,
	"./249-democratic-republic-of-congo.svg": 6385,
	"./250-sint-eustatius.svg": 6386,
	"./254-nato.svg": 6387,
	"./257-sardinia.svg": 6388,
	"./259-european-union.svg": 6389,
	"./262-hawaii.svg": 6390,
	"./NOCOUNTRY.svg": 6391,
	"./ad.svg": 6392,
	"./ae.svg": 6393,
	"./af.svg": 6394,
	"./ag.svg": 6395,
	"./ai.svg": 6396,
	"./al.svg": 6397,
	"./am.svg": 6398,
	"./ao.svg": 6399,
	"./ar.svg": 6400,
	"./as.svg": 6401,
	"./at.svg": 6402,
	"./au.svg": 6403,
	"./aw.svg": 6404,
	"./az.svg": 6405,
	"./ba.svg": 6406,
	"./bb.svg": 6407,
	"./bd.svg": 6408,
	"./be.svg": 6409,
	"./bf.svg": 6410,
	"./bg.svg": 6411,
	"./bh.svg": 6412,
	"./bi.svg": 6413,
	"./bj.svg": 6414,
	"./bm.svg": 6415,
	"./bo.svg": 6416,
	"./br.svg": 6417,
	"./bs.svg": 6418,
	"./bt.svg": 6419,
	"./bw.svg": 6420,
	"./by.svg": 6421,
	"./bz.svg": 6422,
	"./ca.svg": 6423,
	"./cf.svg": 6424,
	"./ch.svg": 6425,
	"./ck.svg": 6426,
	"./cl.svg": 6427,
	"./cm.svg": 6428,
	"./cn.svg": 6429,
	"./co.svg": 6430,
	"./cr.svg": 6431,
	"./cu.svg": 6432,
	"./cv.svg": 6433,
	"./cx.svg": 6434,
	"./cz.svg": 6435,
	"./de.svg": 6436,
	"./dj.svg": 6437,
	"./dk.svg": 6438,
	"./dm.svg": 6439,
	"./do.svg": 6440,
	"./dz.svg": 6441,
	"./ec.svg": 6442,
	"./ee.svg": 6443,
	"./eg.svg": 6444,
	"./er.svg": 6445,
	"./es.svg": 6446,
	"./et.svg": 6447,
	"./fi.svg": 6448,
	"./fj.svg": 6449,
	"./fr.svg": 6450,
	"./ga.svg": 6451,
	"./gb.svg": 6452,
	"./gd.svg": 6453,
	"./ge.svg": 6454,
	"./gg.svg": 6455,
	"./gh.svg": 6456,
	"./gi.svg": 6457,
	"./gl.svg": 6458,
	"./gm.svg": 6459,
	"./gn.svg": 6460,
	"./gq.svg": 6461,
	"./gr.svg": 6462,
	"./gt.svg": 6463,
	"./gu.svg": 6464,
	"./gw.svg": 6465,
	"./hk.svg": 6466,
	"./hn.svg": 6467,
	"./hr.svg": 6468,
	"./ht.svg": 6469,
	"./hu.svg": 6470,
	"./id.svg": 6471,
	"./ie.svg": 6472,
	"./il.svg": 6473,
	"./im.svg": 6474,
	"./in.svg": 6475,
	"./io.svg": 6476,
	"./iq.svg": 6477,
	"./ir.svg": 6478,
	"./is.svg": 6479,
	"./it.svg": 6480,
	"./je.svg": 6481,
	"./jm.svg": 6482,
	"./jo.svg": 6483,
	"./jp.svg": 6484,
	"./ke.svg": 6485,
	"./kg.svg": 6486,
	"./kh.svg": 6487,
	"./ki.svg": 6488,
	"./km.svg": 6489,
	"./kn.svg": 6490,
	"./kp.svg": 6491,
	"./kr.svg": 6492,
	"./kw.svg": 6493,
	"./ky.svg": 6494,
	"./kz.svg": 6495,
	"./lb.svg": 6496,
	"./li.svg": 6497,
	"./lk.svg": 6498,
	"./lr.svg": 6499,
	"./ls.svg": 6500,
	"./lt.svg": 6501,
	"./lu.svg": 6502,
	"./lv.svg": 6503,
	"./ma.svg": 6504,
	"./mc.svg": 6505,
	"./md.svg": 6506,
	"./me.svg": 6507,
	"./mg.svg": 6508,
	"./ml.svg": 6509,
	"./mm.svg": 6510,
	"./mn.svg": 6511,
	"./mo.svg": 6512,
	"./mq.svg": 6513,
	"./mr.svg": 6514,
	"./ms.svg": 6515,
	"./mt.svg": 6516,
	"./mu.svg": 6517,
	"./mv.svg": 6518,
	"./mw.svg": 6519,
	"./mx.svg": 6520,
	"./mz.svg": 6521,
	"./na.svg": 6522,
	"./ne.svg": 6523,
	"./nf.svg": 6524,
	"./ng.svg": 6525,
	"./ni.svg": 6526,
	"./nl.svg": 6527,
	"./no.svg": 6528,
	"./np.svg": 6529,
	"./nr.svg": 6530,
	"./nu.svg": 6531,
	"./nz.svg": 6532,
	"./om.svg": 6533,
	"./pa.svg": 6534,
	"./pe.svg": 6535,
	"./pf.svg": 6536,
	"./pg.svg": 6537,
	"./ph.svg": 6538,
	"./pk.svg": 6539,
	"./pl.svg": 6540,
	"./pr.svg": 6541,
	"./pt.svg": 6542,
	"./pw.svg": 6543,
	"./py.svg": 6544,
	"./qa.svg": 6545,
	"./ro.svg": 6546,
	"./rs.svg": 6547,
	"./ru.svg": 6548,
	"./rw.svg": 6549,
	"./sa.svg": 6550,
	"./sb.svg": 6551,
	"./sc.svg": 6552,
	"./sd.svg": 6553,
	"./se.svg": 6554,
	"./sg.svg": 6555,
	"./si.svg": 6556,
	"./sk.svg": 6557,
	"./sl.svg": 6558,
	"./sm.svg": 6559,
	"./sn.svg": 6560,
	"./so.svg": 6561,
	"./sr.svg": 6562,
	"./st.svg": 6563,
	"./sv.svg": 6564,
	"./sy.svg": 6565,
	"./sz.svg": 6566,
	"./td.svg": 6567,
	"./tg.svg": 6568,
	"./th.svg": 6569,
	"./tj.svg": 6570,
	"./tk.svg": 6571,
	"./tm.svg": 6572,
	"./tn.svg": 6573,
	"./to.svg": 6574,
	"./tr.svg": 6575,
	"./tt.svg": 6576,
	"./tv.svg": 6577,
	"./tz.svg": 6578,
	"./ua.svg": 6579,
	"./ug.svg": 6580,
	"./us.svg": 6581,
	"./uy.svg": 6582,
	"./vg.svg": 6583,
	"./vn.svg": 6584,
	"./vu.svg": 6585,
	"./ws.svg": 6586,
	"./ye.svg": 6587,
	"./za.svg": 6588,
	"./zm.svg": 6589,
	"./zw.svg": 6590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6329;